<nav class="topbar">
  <div class="topbar-left">
    <button (click)="toggleNavigation()" [class.btn-outline-warning]="notProd()" class="btn btn-light btn-icon collapse-btn" type="button">
      <em class="far" [ngClass]="notProd() ? 'fa-exclamation-triangle' : 'fa-bars'"></em>
    </button>
    @if (notProd()) {
    <!-- Version lue de l'instance, et non ecrite en dur : le bandeau annoncait
         encore 3.9 alors que l'application etait en 3.11. -->
    <span class="badge rounded-pill not-prod-chip">Mir hors production {{ version?.version }}</span>
    }
  </div>

  <div class="topbar-right">
    <div class="d-none d-md-block">
      <mir-gestimmo-banner></mir-gestimmo-banner>
    </div>

    @if (user?.realLoggedUsername) {
    <button (click)="impersonateLogout()" class="btn btn-outline-danger btn-icon" title="Quitter l'impersonation" type="button">
      <em class="far fa-eye"></em>
    </button>
    }

    @if (version?.isAuthorized('ANNOUNCE') && user?.isAuthorized('ROLE_SAPEUR')) {
    <!-- `insideClick` garde le menu ouvert quand on coche une annonce comme lue :
         on en marque souvent plusieurs d'affilee. Mais il le retient AUSSI quand
         on suit un lien, et le menu restait alors ouvert par-dessus la page
         d'arrivee -- de quoi croire que le lien ne fait rien, surtout depuis
         /annonce ou l'URL ne change meme pas. D'ou la reference #announceDropdown
         et le `hide()` porte par chaque lien de navigation. -->
    <div
      #announceDropdown="bs-dropdown"
      [insideClick]="true"
      class="dropdown announce-bell d-none d-md-block"
      dropdown
    >
      <a
        dropdownToggle
        class="btn btn-light btn-icon announce-bell-toggle"
        [class.announce-bell-toggle--unread]="announces?.myNotificationsUnread.length > 0"
      >
        @if (announces?.myNotificationsUnread.length > 0) {
        <span
          class="announce-count"
          [attr.aria-label]="announces.myNotificationsUnread.length + ' annonce(s) non lue(s)'"
          >{{ announces.myNotificationsUnread.length }}</span
        >
        } @else {
        <em class="fas fa-bell"></em>
        }
      </a>
      <div *dropdownMenu class="announce-dropdown dropdown-menu">
        <div class="announce-dropdown-header">
          <span>Annonces</span>
          @if (announces.myNotificationsUnread.length > 0) {
          <span class="announce-dropdown-count">{{ announces.myNotificationsUnread.length }} non lue(s)</span>
          }
        </div>

        <div class="announce-dropdown-list">
          @if (announces.myNotificationsUnread.length > 0) {
          @for (n of announces.myNotificationsUnread; track n.id) {
          <div class="announce-dropdown-item">
            <a
              (click)="announceDropdown.hide()"
              [routerLink]="['/annonce', n.id]"
              class="announce-dropdown-item-link"
            >
              <span class="announce-level-dot" [ngClass]="'level-' + (n.level || n.type)?.toLowerCase()"></span>
              <span class="announce-dropdown-item-title">{{ n.title }}</span>
            </a>
            <button (click)="markAsRead(n)" class="btn btn-outline-success btn-icon btn-sm announce-mark-read-btn" title="Marquer comme lue" type="button">
              <em class="fal fa-check"></em>
            </button>
          </div>
          }
          } @else {
          <p class="announce-dropdown-empty">Aucune annonce non lue.</p>
          }
        </div>

        <a
          (click)="announceDropdown.hide()"
          [routerLink]="['/annonce']"
          class="announce-dropdown-footer"
        >
          Consulter les annonces
        </a>
      </div>
    </div>
    }

    <!-- Le bouton porte le nom de l'utilisateur connecte plutot que le mot"Deconnexion" : l'icone de sortie porte deja le sens de l'action, et
         savoir SOUS QUEL COMPTE on est vaut mieux dans une caserne ou les
         postes sont partages. `aria-label` conserve l'intitule de l'action
         pour les lecteurs d'ecran, a qui un nom propre ne dirait rien. -->
    <button
      type="button"
      class="btn btn-light logout-btn"
      title="Déconnexion"
      aria-label="Déconnexion"
      (click)="logout()"
    >
      <span class="logout-btn-text">{{ user?.rank }} {{ user?.fullname }}</span>
      <em class="far fa-sign-out"></em>
    </button>
  </div>
</nav>
